import classNames from 'classnames';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { TFunction } from 'i18next';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import UDTabs from 'ud-ui/components/tabs';
import { Tab } from 'ud-ui/components/tabs/interfaces';
import UDText from 'ud-ui/components/text';
import { PlayerViewTab } from 'modules/players/domain/enums/player-view-tab';

/** Подписи и порядок вкладок; hash-и — в `PlayerViewTab`, они часть роута. */
const getPlayerViewTabs = (t: TFunction): Tab[] => [
  { hash: PlayerViewTab.COMMON, label: t('player.viewTabs.common') },
  { hash: PlayerViewTab.TEAMS, label: t('player.viewTabs.teams') },
  { hash: PlayerViewTab.MOMENTS, label: t('player.viewTabs.moments') },
];

type CreateEditFormParams = {
  tab: Tab;
  count?: number;
  isActive?: boolean;
  state?: any;
};

const createEditFormTab = (params: CreateEditFormParams): Tab => {
  const { tab, count, isActive, state } = params;

  if (count !== undefined) {
    const badgeBgColor = isActive ? 'bg-surfaceWhite' : 'bg-accentNaplesYellow';
    const className = classNames([
      'text-surfaceRaisinBlack50',
      badgeBgColor,
      'p-1',
      'rounded-[4px]',
      'ml-2',
      'line-height-1',
      'caption-1',
    ]);

    return {
      hash: tab.hash,
      label: (
        <>
          {tab.label}{' '}
          <UDText type="subhead" className={className}>
            {count}
          </UDText>
        </>
      ),
    };
  }

  return { ...tab, state };
};

type PlayerEditFormTabsProps = {
  state?: any;
};

const PlayerEditFormTabs = ({ state }: PlayerEditFormTabsProps) => {
  const { t } = useTranslation();
  const location = useLocation();
  const activeTab = (location.pathname || '').split('/').at(-1);

  const tabs = useMemo(() => {
    return getPlayerViewTabs(t).map((tab) =>
      createEditFormTab({
        tab: tab,
        isActive: tab.hash === activeTab,
        state: state,
      }),
    );
  }, [t, activeTab, state]);

  return <UDTabs tabs={tabs} defaultTab={tabs[0]} activeRoutePattern={Pages.PLAYERS.VIEW} />;
};

export default PlayerEditFormTabs;
